unit Unit4;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls, Vcl.Grids, WEBLib.DBCtrls,
  WEBLib.Controls, WEBLib.ExtCtrls, WEBLib.CDS, Data.DB, WEBLib.DB,
  Vcl.Graphics, WEBLib.Buttons, Vcl.Imaging.jpeg;

type
  TForm4 = class(TForm)
    WebLabel26: TLabel;
    WebLabel7: TLabel;
    WebLabel1: TLabel;
    WebLabel2: TLabel;
    WebLabel3: TLabel;
    WebLabel4: TLabel;
    WebLabel5: TLabel;
    WebLabel6: TLabel;
    Drzewa: TImageControl;
    WebLabel8: TLabel;
    procedure WebFormCreate(Sender: TObject);
  private
    { Private declarations }
  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

var
  Form4: TForm4;

implementation

{$R *.dfm}

uses uFrmMain;

procedure TForm4.WebFormCreate(Sender: TObject);
var    DRZE   : Real;
begin
WebLabel2.Caption:=FrmMain.WebEdit5.Text;
DRZE:=Round(StrtoFloat(FrmMain.WebEdit5.Text)/10);
WebLabel5.Caption:=FloattoStr(DRZE);
end;

procedure TForm4.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebLabel26 := TLabel.Create(Self);
  WebLabel7 := TLabel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  WebLabel5 := TLabel.Create(Self);
  WebLabel6 := TLabel.Create(Self);
  Drzewa := TImageControl.Create(Self);
  WebLabel8 := TLabel.Create(Self);

  WebLabel26.BeforeLoadDFMValues;
  WebLabel7.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  WebLabel5.BeforeLoadDFMValues;
  WebLabel6.BeforeLoadDFMValues;
  Drzewa.BeforeLoadDFMValues;
  WebLabel8.BeforeLoadDFMValues;
  try
    Name := 'Form4';
    Width := 710;
    Height := 467;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    WebLabel26.SetParentComponent(Self);
    WebLabel26.Name := 'WebLabel26';
    WebLabel26.Left := 8;
    WebLabel26.Top := 59;
    WebLabel26.Width := 47;
    WebLabel26.Height := 18;
    WebLabel26.Caption := 'Wynik';
    WebLabel26.Font.Charset := DEFAULT_CHARSET;
    WebLabel26.Font.Color := clMenuHighlight;
    WebLabel26.Font.Height := -15;
    WebLabel26.Font.Name := 'Tahoma';
    WebLabel26.Font.Style := [fsBold];
    WebLabel26.HeightPercent := 100.000000000000000000;
    WebLabel26.ParentFont := False;
    WebLabel26.WidthPercent := 100.000000000000000000;
    WebLabel7.SetParentComponent(Self);
    WebLabel7.Name := 'WebLabel7';
    WebLabel7.Left := 8;
    WebLabel7.Top := 445;
    WebLabel7.Width := 211;
    WebLabel7.Height := 13;
    WebLabel7.Caption := 'Kalkulator fotowoltaiczny - Pro-Sun (c) 2022';
    WebLabel7.Color := clYellow;
    WebLabel7.HeightPercent := 100.000000000000000000;
    WebLabel7.Transparent := False;
    WebLabel7.WidthPercent := 100.000000000000000000;
    WebLabel1.SetParentComponent(Self);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 24;
    WebLabel1.Top := 85;
    WebLabel1.Width := 305;
    WebLabel1.Height := 18;
    WebLabel1.Caption := 'Osi'#261'gn'#261#322'e'#347' wynik  '#347'ladu w'#281'glowego wynosz'#261'cy';
    WebLabel1.Font.Charset := DEFAULT_CHARSET;
    WebLabel1.Font.Color := clWindowText;
    WebLabel1.Font.Height := -15;
    WebLabel1.Font.Name := 'Tahoma';
    WebLabel1.Font.Style := [];
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.ParentFont := False;
    WebLabel1.WidthPercent := 100.000000000000000000;
    WebLabel2.SetParentComponent(Self);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 335;
    WebLabel2.Top := 73;
    WebLabel2.Width := 17;
    WebLabel2.Height := 33;
    WebLabel2.Caption := '0';
    WebLabel2.Font.Charset := DEFAULT_CHARSET;
    WebLabel2.Font.Color := clMenuHighlight;
    WebLabel2.Font.Height := -27;
    WebLabel2.Font.Name := 'Tahoma';
    WebLabel2.Font.Style := [fsBold];
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.ParentFont := False;
    WebLabel2.WidthPercent := 100.000000000000000000;
    WebLabel3.SetParentComponent(Self);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 416;
    WebLabel3.Top := 73;
    WebLabel3.Width := 170;
    WebLabel3.Height := 33;
    WebLabel3.Caption := 'ton CO2/rok';
    WebLabel3.Font.Charset := DEFAULT_CHARSET;
    WebLabel3.Font.Color := clMenuHighlight;
    WebLabel3.Font.Height := -27;
    WebLabel3.Font.Name := 'Tahoma';
    WebLabel3.Font.Style := [fsBold];
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.ParentFont := False;
    WebLabel3.WidthPercent := 100.000000000000000000;
    WebLabel4.SetParentComponent(Self);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 24;
    WebLabel4.Top := 116;
    WebLabel4.Width := 433;
    WebLabel4.Height := 18;
    WebLabel4.Caption := 'Do zmagazynowania takiej ilo'#347'ci CO2 potrzebne s'#261' drzewa  w ilo'#347'ci';
    WebLabel4.Font.Charset := DEFAULT_CHARSET;
    WebLabel4.Font.Color := clWindowText;
    WebLabel4.Font.Height := -15;
    WebLabel4.Font.Name := 'Tahoma';
    WebLabel4.Font.Style := [];
    WebLabel4.HeightPercent := 100.000000000000000000;
    WebLabel4.ParentFont := False;
    WebLabel4.WidthPercent := 100.000000000000000000;
    WebLabel5.SetParentComponent(Self);
    WebLabel5.Name := 'WebLabel5';
    WebLabel5.Left := 473;
    WebLabel5.Top := 104;
    WebLabel5.Width := 17;
    WebLabel5.Height := 33;
    WebLabel5.Caption := '0';
    WebLabel5.Font.Charset := DEFAULT_CHARSET;
    WebLabel5.Font.Color := clGreen;
    WebLabel5.Font.Height := -27;
    WebLabel5.Font.Name := 'Tahoma';
    WebLabel5.Font.Style := [fsBold];
    WebLabel5.HeightPercent := 100.000000000000000000;
    WebLabel5.ParentFont := False;
    WebLabel5.WidthPercent := 100.000000000000000000;
    WebLabel6.SetParentComponent(Self);
    WebLabel6.Name := 'WebLabel6';
    WebLabel6.Left := 514;
    WebLabel6.Top := 104;
    WebLabel6.Width := 39;
    WebLabel6.Height := 33;
    WebLabel6.Caption := 'szt';
    WebLabel6.Font.Charset := DEFAULT_CHARSET;
    WebLabel6.Font.Color := clGreen;
    WebLabel6.Font.Height := -27;
    WebLabel6.Font.Name := 'Tahoma';
    WebLabel6.Font.Style := [fsBold];
    WebLabel6.HeightPercent := 100.000000000000000000;
    WebLabel6.ParentFont := False;
    WebLabel6.WidthPercent := 100.000000000000000000;
    Drzewa.SetParentComponent(Self);
    Drzewa.Name := 'Drzewa';
    Drzewa.Left := 231;
    Drzewa.Top := 143;
    Drzewa.Width := 456;
    Drzewa.Height := 293;
    Drzewa.HeightPercent := 100.000000000000000000;
    Drzewa.WidthPercent := 100.000000000000000000;
    Drzewa.ChildOrder := 8;
    Drzewa.Picture.LoadFromFile('Unit4.Drzewa.Picture.jpg');
    WebLabel8.SetParentComponent(Self);
    WebLabel8.Name := 'WebLabel8';
    WebLabel8.Left := 538;
    WebLabel8.Top := 439;
    WebLabel8.Width := 150;
    WebLabel8.Height := 16;
    WebLabel8.Caption := 'Kontakt: biuro@pro-sun.pl';
    WebLabel8.Font.Charset := DEFAULT_CHARSET;
    WebLabel8.Font.Color := clBlue;
    WebLabel8.Font.Height := -13;
    WebLabel8.Font.Name := 'Tahoma';
    WebLabel8.Font.Style := [];
    WebLabel8.HeightPercent := 100.000000000000000000;
    WebLabel8.ParentFont := False;
    WebLabel8.WidthPercent := 100.000000000000000000;
  finally
    WebLabel26.AfterLoadDFMValues;
    WebLabel7.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    WebLabel5.AfterLoadDFMValues;
    WebLabel6.AfterLoadDFMValues;
    Drzewa.AfterLoadDFMValues;
    WebLabel8.AfterLoadDFMValues;
  end;
end;

end.